import { useCallback, useState } from 'react';
import axios from 'axios';
import { API_PATH } from 'config';
import { handleApiError } from 'utils/handlers';

// Migrado a axios: hereda el interceptor global (auth + retry 401). Antes leía
// getAccessTokenApi() directo y quedaba fuera del refresh.

export const STATUS_LOADING = 'status_loading';
export const STATUS_ERROR = 'status_error';
export const STATUS_DEFAULT = 'status_default';

export const useCallGetApi = (url, options = {}) => {
  const { defaultValue = null, config = null, defaultStatus } = options;

  const [payload, setPayload] = useState(defaultValue);

  // Reload indica si se debe volver a pedir los datos a la API
  const [status, setStatus] = useState(defaultStatus || STATUS_DEFAULT);
  const [errorInfo, setErrorInfo] = useState(null);

  const call = useCallback(async () => {
    setStatus(STATUS_LOADING);
    try {
      const { data } = await axios.get(`${API_PATH}${url}`, { ...config });
      setPayload(data);
      setStatus(STATUS_DEFAULT);
    } catch (err) {
      // Preserva la forma del error que esperaban errorInfo/handleApiError:
      // { status, message } cuando el backend respondió; el err crudo si fue red.
      const normalized = err.response
        ? { status: err.response.status, message: err.response.data?.error || 'Error desconocido' }
        : err;
      setStatus(STATUS_ERROR);
      setErrorInfo(normalized);
      handleApiError(normalized);
    }
  }, [url]);
  return [payload, call, status, errorInfo];
};
